export default "__VITE_ASSET__9f21fcb3__"